"use client";
import { useStore } from "@lib/context/store-context";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

interface NotFoundProps {
  message?: string;
  linkText?: string;
  linkHref?: string;
}

export default function BusinessNotFound({
  message = "The page you tried to access does not exist.",
  linkText = "Go to home",
  linkHref = "/",
}: NotFoundProps) {
  const router = useRouter();
  const { setLoading } = useStore();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[250px] h-[calc(100vh-450px)] px-4">
      <h1 className="text-2xl-semi text-gray-900 text-center leading-8 mb-4">Business Details Not Found</h1>
      <p className="text-small-regular text-gray-700 text-center">{message}</p>
      {linkHref === "back" ? (
        <button
          onClick={() => router.back()}
          className="mt-4 underline text-base-regular text-gray-900"
        >
          {linkText}
        </button>
      ) : (
        <Link
          href={linkHref}
          className="mt-4 underline text-base-regular text-gray-900"
          prefetch={false}
        >
          {linkText}
        </Link>
      )}
    </div>
  );
}
